import React 		from 'react';
import ReactDOM 	from 'react-dom';

import BLComponent 	from '../core/_BLComponent.jsx'

export default class LoginRequired extends BLComponent 
{
	//static propTypes	= {};
	//static defaultProps	= {};

	//static getDerivedStateFromProps( nextProps, prevState ) {}

	constructor ( props, context )
	{
		super( props, context );

		this.state			= {};
		this._redirectUrl	= blapp.util.getUrlVar( "redirect" );
	}

	componentDidMount()
	{
		this.hideClassicLink();

		blapp.session.onSessionUpdate( () => this.onSessionUpdate() );
		this.onSessionUpdate();
	}

	hideClassicLink()
	{
		var		ref = blapp.refs.get( "footer" );

		if ( ref != null )
			ref.showClassicLink( false );
		else
			setTimeout( () => { this.hideClassicLink() }, 0 );
	}

	render() 
	{
		return (
			<div className="main main--white l-pad--xl text--center">
				<h2 className="page-title l-margin-bottom">
					{$T("LOGIN_TO_PROCEED")}
				</h2>
				<div className="l-margin-bottom--xl">
					{$T( "LOGIN_REQUIRED" )}
				</div>					
				<button className="btn btn--cta l-margin-bottom" onClick={(e)=>this.onContinue( e )}>{$T("LOGIN_OR_REGISTER")}</button>
				<div dangerouslySetInnerHTML={{__html: $T("BACK_TO_BL", [ "https://" + blapp.config.getHost( "www" ) + "/v2/main.page" ])}}/>
			</div>
		);		
	}

	onContinue( e )
	{
		blapp.refs.get( "header" ).toggleMenu( "login" );
	}	

	onSessionUpdate()
	{
		if ( blapp.session.isLoggedIn() && this._redirectUrl )
		{
			window.location.href	= this._redirectUrl;
		}
	}
};

var $T	= BLComponent.createTextMap( 
	{
		"LOGIN_TO_PROCEED":
			{
				"en":	"Log in to proceed"
			,	"kr":	"로그인을 해 주세요!"
			,	"es":	"Entra para continuar"
			}
	,	"LOGIN_REQUIRED":
			{
				"en":	"This page is for BrickLink members only. Please log in or register as a member to access this page."
			,	"kr":	"이 페이지는 브릭링크 멤버를 위한 전용 페이지입니다. 진행을 위해서는 로그인 또는 회원 가입을 해 주세요."
			,	"es":	"Esta página es solo para mienbros de BrickLink. Entra o regístrate como miembro para acceder a esta página."
			}
	,	"LOGIN_OR_REGISTER":
			{
				"en":	"Log in or register"
			,	"kr":	"로그인 또는 회원가입"
			,	"es":	"Entrar o registrarse"
			}
	,	"BACK_TO_BL":
			{
				"en":	"or go to <a href='{{$0}}'>BrickLink.com</a>"
			,	"kr":	"또는 <a href='{{$0}}'>메인 페이지</a>로 이동"
			,	"es":	"o dirígete a <a href='{{$0}}'>BrickLink.com</a>"
			}
	}
);


document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<LoginRequired blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-login' )
						);
	}
);
 

